import { required } from '../../components/antd/form/FormValidation';

const stripHtml = (value) => value.replace(/<[^>]*>/g, '');

const htmlEntityDecode = (value) => {
  if (typeof document === 'undefined') {
    return value;
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
};

const isMeaningfulValue = (value) => {
  if (value === null || value === undefined) {
    return false;
  }

  if (value === 'null' || value === 'undefined') {
    return false;
  }

  if (typeof value !== 'string') {
    return Boolean(value);
  }

  const normalized = value.trim();
  if (normalized === '') {
    return false;
  }

  // Rich-editor content can be meaningful even without plain text.
  if (/<(img|video|iframe|object|embed|svg|canvas|hr)\b/iu.test(normalized)) {
    return true;
  }

  const textOnly = htmlEntityDecode(stripHtml(normalized))
    // normalize editor leftovers (NBSP + zero-width chars)
    .replace(/[\u00A0\u200B\u200C\u200D\uFEFF]/g, ' ')
    .trim();

  return textOnly.replace(/\s+/gu, '') !== '';
};

//Purpose: if user wants to add only one type of version (en or sk), and leave the other empty,
// the validation for other block needs to be switched off
//Note: usage of promise - Ant Design's form validation framework expects asynchronous validation rules to return a Promise
export const validateFieldFunc =
  (formIsEmpty, formIsFilled, translation) => async (_, value) => {
    if (!formIsEmpty && !formIsFilled && !isMeaningfulValue(value)) {
      return Promise.reject(new Error(required(translation).message));
    }

    return Promise.resolve();
  };

const evaluateForm = (
  form,
  language,
  title = 'title',
  slugOrPosition = 'slug',
  condition,
) => {
  const titleValue = form.getFieldValue(`${title}_${language}`);
  const slugOrPositionValue = form.getFieldValue(
    `${slugOrPosition}_${language}`,
  );
  const contentValue = form.getFieldValue(`content_${language}`);
  return condition(titleValue, slugOrPositionValue, contentValue);
};

export const formIsEmpty = (
  form,
  language,
  title = 'title',
  slugOrPosition = 'slug',
  showPredefined = false,
) =>
  evaluateForm(
    form,
    language,
    title,
    slugOrPosition,
    (tValue, SoPValue, CValue) =>
      !isMeaningfulValue(tValue) &&
      !isMeaningfulValue(SoPValue) &&
      (showPredefined || !isMeaningfulValue(CValue)),
  );

export const formIsFilled = (
  form,
  language,
  title = 'title',
  slugOrPosition = 'slug',
  showPredefined = false,
) =>
  evaluateForm(
    form,
    language,
    title,
    slugOrPosition,
    (tValue, SoPValue, CValue) =>
      isMeaningfulValue(tValue) &&
      isMeaningfulValue(SoPValue) &&
      (showPredefined || isMeaningfulValue(CValue)),
  );

export const clearFieldErrors = (form, fields) => {
  const currentFields = form.getFieldsError(fields);

  const fieldsToUpdate = currentFields
    .filter(({ errors }) => errors.length > 0)
    .map(({ name }) => ({
      name,
      errors: [],
    }));

  if (fieldsToUpdate.length > 0) {
    form.setFields(fieldsToUpdate);
  }
};
